import { render, staticRenderFns } from "./PremiumForm.vue?vue&type=template&id=3a38f40f&scoped=true&"
import script from "./PremiumForm.vue?vue&type=script&lang=js&"
export * from "./PremiumForm.vue?vue&type=script&lang=js&"
import style0 from "./PremiumForm.vue?vue&type=style&index=0&id=3a38f40f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38f40f",
  null
  
)

export default component.exports